module.exports = __webpack_public_path__ + "static/media/Lahugala.d211768b.png";